export const MAX_SIZE_IMAGE_MB = 10;
export const getFileSizeMB = (size) => size / 1024 / 1024;